import styled, { css } from "styled-components";
import { Link } from "gatsby-link";
import Icon from "components/Icon";
import Image from "components/Image";
import { media } from "components/Theme/default-theme";

export const ItemLinkIcon = styled(Icon)`
  svg {
    width: 8px;
    > * {
      stroke: #382e2b;
    }
  }
`;

export const ItemLabel = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  margin-top: 0;
  text-align: left;
  transition: all 0.35s ease-out;
  color: #382e2b !important;
  text-decoration-color: #382e2b !important;
`;

export const ItemLabelWrapper = styled.div`
  display: inherit;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  width: 100%;
  background: #ffffff !important;
`;

export const ItemImage = styled(Image)`
  display: inherit;
  flex: 1;
  width: 100%;
  aspect-ratio: 1;

  img {
    object-fit: cover !important;
  }
`;

export const Item = styled(Link)`
  display: inherit;
  flex-direction: column;
  border: 1px solid #dbd9d6;
  flex: 1/3;
  width: calc(33.333% - (44px * 2 / 3));
  text-decoration-color: #382e2b;

  @media screen and (max-width: 1300px) {
    width: calc(49% - (44px * 2 / 3));
    margin: 0 5px;
  }

  @media screen and (max-width: 560px) {
    width: 100%;
    margin: 0 5px;
  }
`;

export const ItemsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 40px;
  width: auto;
  padding: 20px;

  @media screen and (max-width: 1300px) {
    justify-content: center;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0 auto;
  font-style: normal;
  font-weight: 400;
  font-size: 35px;
  line-height: 44px;
  text-align: center;
  text-transform: uppercase;
  padding: 50px 32px;
  border-bottom: 1px solid #ccc;
  width: 95%;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0.5rem;
  ${({ background, font_color }) => css`
    background: ${background || "#fff"};
    color: ${font_color || "#382e2b"};
  `}

  ${ItemsWrapper} {
    ${({ font_color }) => css`
        ${Item}:hover {
          text-decoration-color: ${font_color || "#382e2b"} !important;
          ${ItemLabelWrapper} > * {
            color: ${font_color || "#382e2b"} !important;
            svg > * {
              stroke: ${font_color || "#382e2b"}
            } 
          }
        }
      }
    `}
  }

  ${media.tablet} {
    padding: 2rem 0.5rem;
  }

  ${media.laptop} {
    padding: 10px 50px;
    ${SectionTitle} {
      max-width: 1300px;
    }

    ${ItemsWrapper} {
      max-width: 1300px;
    }
  }

  ${media.desktop} {
    padding: 50px 0 44px;
    ${SectionTitle} {
      max-width: 1577px;
    }

    ${ItemsWrapper} {
      max-width: 1577px;
    }
  }
`;
